import type { BoardMenuItemLocation } from '@atlassian/jira-software-connect-toolbar/src/ui/board-connect-menu-items/types.tsx';

export const boardConnectAppLocations: BoardMenuItemLocation[] = [
	'board-tools-1',
	'view-actions-work',
	'view-actions-print',
];
